export default {
  title01: "მიმდინარე ამინდი",
  title02: "24 საათი",
  title03: "ნახე 10-დღიანი ამინდის პროგნოზი",
  title04: "AQI",
  title05: "ნახე ყველა ინფორმაცია",
  title06: "მზის ამოსვლა და ჩასვლა",
  title07: "მთვარის ფაზა",
  title08: "შემდეგი სავსე მთვარე",
  title09: "შემდეგი ახალი მთვარე",
  title10: "დღე",
  title11: "ღამე",
  title12: "მზის ამოსვლა",
  title13: "მზის ჩასვლა",
  title14: "მთვარის ამოსვლა",
  title15: "მთვარის ჩასვლა",
  title16: "წყარო",
  title17: "დაწყება",
  title18: "დასასრული",
  title19: "გამოიყენე მიმდინარე მდებარეობა",
  title20: "მოძებნე ქალაქი",
  title21: "აღქმადი ტემპერატურა",
  title22: "აღქმადი ტემპერატურა (ჩრდილში)",
  title23: "ახლა",
  title24: "დღეს",
  title25: "კვი",
  title26: "ორშ",
  title27: "სამ",
  title28: "ოთხ",
  title29: "ხუთ",
  title30: "პარ",
  title31: "შაბ",
  title32: "იტვირთება...",
  title33: "ახლა",
  title34: "საათობრივი",
  title35: "დღიური",
  title36: "მზე & მთვარე",
  title37: "ჰაერის ხარისხი",
  title38: "დაგვიკავშირდით : xlf550402@gmail.com",
  title39: "კონფიდენციალურობის პოლიტიკა",
  title40: "საავტორო უფლება © comfortweather.com 2020 - 2024. ყველა უფლება დაცულია.",
  title41: "მონაცემები მოწოდებულია [LOGO]",
  title42: "მაქს",
  title43: "მინ",
  title44: "მიღება",
  title45:
    "გმადლობთ ComfortWeather-ის გამოყენებისთვის! თქვენი კანონიერი უფლებებისა და ინტერესების უკეთ დასაცავად, გთხოვთ, გამოყენებამდე ყურადღებით წაიკითხოთ „კონფიდენციალურობის პოლიტიკა“.",
  title46: "",
  title47: "",
  title48: "",
  title49: "დაგვიკავშირდით : xyjph123@gmail.com",
  title50: "საავტორო უფლება © 24hweather.com 2020 - 2026. ყველა უფლება დაცულია.",
  title51:
    "გმადლობთ 24hweather-ის გამოყენებისთვის! თქვენი კანონიერი უფლებებისა და ინტერესების უკეთ დასაცავად, გთხოვთ, წაიკითხოთ",
  title52: "თქვენი მდებარეობა შეიცვალა. გსურთ მისი განახლება?",
  title53: "დადასტურება",
  title54: "გაუქმება",
  title55: "უკან",
  title56: "სიახლეები",
  title57: "ამინდის განახლება...",
  title58: "ამინდი განახლდა",
  title59: "ნახე ყველა",
  title60: "",
  title61: "გუშინ",
  title62: "ხვალ",
  title63: "",
  title64: "დღევანდელი დეტალები",
  title65: "only for India",
  title66: "ცხოვრების სტილის ინდექსები",
  title67: "ცხოვრების სტილის ინდექსები",
  title68: "Next 7 Days Rahu Kaal Timings for",
  title69: "To",
  title70: "to",
  title71: "ჰაერის ხარისხის ინდექსი",

  title102: "Hard to dry",
  title103: "Slow drying",
  title104: "Dries well",
  title105: "Quick drying",
  title106: "Very fast drying",

  title107: "Not suitable",
  title108: "Modest experience",
  title109: "Good for water fun",
  title110: "Very suitable",
  title111: "Perfect conditions",

  title112: "Supportive to health",
  title113: "Neutral conditions",
  title114: "Slightly higher risk",
  title115: "High risk",
  title116: "Very high risk",

  title117: "Not suitable",
  title118: "Somewhat suitable",
  title119: "Good for outdoors",
  title120: "Very suitable",
  title121: "Excellent conditions",

  title122: "Very dry conditions",
  title123: "Likely dry",
  title124: "Slightly dry",
  title125: "Not likely dry",
  title126: "Very unlikely dry",

  title127: "Not recommended",
  title128: "Acceptable",
  title129: "Good day",
  title130: "Very good conditions",
  title131: "Ideal conditions",
};
